import { SidebarCartItem } from '@/components/SidebarCardShop/SidebarCartItem';
import React, { useMemo } from 'react';
import { MdOutlineSurfing } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { Render } from '@/helpers/Render';
import { Format } from '@/helpers/formatters';
import { useModalParkStore } from '@/store/park/modalParkStore';
import { useModalServicesStore } from '@/store/services/modalServicesStore';
import { useModalShoppingStore } from '@/store/shopping/modalShoppingStore';
import { useShoppingCartStore } from '@/store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';
import ReactIcon from '../ReactIcon';
import {
    ActionsButtonsFooterWrap,
    ElementTotalSum,
    ElementsWrap,
    EmpyValuesCard,
    ShopElementsWrap,
    SideCardRelativeWrap,
    SideCardShopWrap,
    DiscountValue,
    ElementValuesSum
} from './styles';

export const SidebarCardShop: React.FC = () => {
    const { cartIsVisible, cartValues, setCurrentIdRemoving } =
        useShoppingCartStore();
    const { setIsVisibleShoppingWave } = useModalShoppingStore();
    const { isVisible: isVisibleService, setIsVisibleServices } =
        useModalServicesStore();
    const { setIsVisiblePark } = useModalParkStore();

    const navigate = useNavigate();

    // Soma de todos os valores no carrinho
    const sumValuesCard = useMemo(() => {
        if (!cartValues) return 0;

        return cartValues.reduce(
            (accumulator, item) => accumulator + item.value,
            0
        );
    }, [cartValues]);

    const sumDiscountValue = useMemo(() => {
        if (!cartValues) return 0;

        return cartValues.reduce(
            (accumulator, item) => accumulator + (item.discountValue ?? 0),
            0
        );
    }, [cartValues])

    function handleNavigateCheckout() {
        setIsVisibleServices(false);
        setIsVisibleShoppingWave(false);
        setIsVisiblePark(false);
        navigate('/checkout');
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    const isVoucher = sumValuesCard === 0 && (cartValues ?? []).length > 0;

    return (
        <SideCardRelativeWrap cartIsVisible={cartIsVisible}>
            <SideCardShopWrap>
                <ShopElementsWrap aria-selected={!cartValues?.length}>
                    <Render show={!!cartValues?.length}>
                        <ElementsWrap>
                            {cartValues?.map((cartElement, index) => (
                                <React.Fragment key={`${cartElement.id}-${cartElement.scheduleId ?? ''}-${index}`}>
                                    <SidebarCartItem
                                        item={cartElement}
                                        setCurrentIdRemoving={
                                            setCurrentIdRemoving
                                        }
                                    />
                                    <div className="divider" />
                                </React.Fragment>
                            ))}
                        </ElementsWrap>
                    </Render>
                    <Render show={!cartValues?.length}>
                        <EmpyValuesCard>
                            <ReactIcon Icon={MdOutlineSurfing} size={'2rem'} />
                            <p>Seu carrinho está esperando por aventuras!</p>
                        </EmpyValuesCard>
                    </Render>
                </ShopElementsWrap>
                <ActionsButtonsFooterWrap>
                    <ElementTotalSum>
                        {
                            sumDiscountValue > 0
                            ? 
                                <ElementValuesSum>
                                    <span>Desconto</span>
                                    <DiscountValue> {Format.currency(sumDiscountValue)} </DiscountValue>
                                </ElementValuesSum>
                            : null
                        }
                        <ElementValuesSum>
                            <span>Total</span>
                            <h2> {Format.currency(sumValuesCard - sumDiscountValue)} </h2>
                        </ElementValuesSum>
                    </ElementTotalSum>
                    <BigButton
                        color={cartValues?.length ? 'primary' : 'secondary'}
                        bgColor={cartValues?.length ? 'primary' : 'secondary'}
                        children={isVoucher ? 'Resgatar voucher' : 'Ir para pagamento'}
                        disabled={!cartValues?.length}
                        cursorBlocked={!cartValues?.length}
                        padding="0.5rem 0.75rem"
                        onClick={handleNavigateCheckout}
                    />
                    {!isVisibleService && (
                        <BigButton
                            color="primary"
                            bgColor="secondary"
                            children={'Adquirir outros serviços'}
                            onClick={() => {
                                setIsVisibleShoppingWave(false);
                                setIsVisibleServices(true);
                            }}
                            padding="0.5rem 0.75rem"
                        />
                    )}
                </ActionsButtonsFooterWrap>
            </SideCardShopWrap>
        </SideCardRelativeWrap>
    );
};